// extracted by mini-css-extract-plugin
export default {"arrows":"reusableFunctions_arrows__Zq-Ab"};